import {Component, OnInit} from '@angular/core';
import {OptionsComponent} from '../options/options.component';
import {CreditOptions} from '../../../model/eligibility-check/credit-options.model';
import {SharedEligibilityCheckForm} from '../eligibility-check-form/eligibility-check-form.component';
import {Router} from '@angular/router';
import {CreditOptionsCategorizer} from '../options/credit-options-categorizer';
import {StorageService} from '../../../service/storage.service';
import {SubventionPreferenceService} from '../../../service/subvention-preference.service';
import {ChannelPartnerService} from '../../../service/channel-partner.service';
import {EligibilityCheckService} from '../../../service/eligibility-check.service';
import {Location} from '@angular/common';

@Component({
    templateUrl: './advance-emi-options.component.html',
    styleUrls: ['./advance-emi-options.component.scss']
})
export class AdvanceEmiOptionsComponent extends OptionsComponent implements OnInit {

    public requestedLoanAmount: number;
    public advanceEmiCount: number;
    private location: Location;


    constructor(router: Router, categorizer: CreditOptionsCategorizer, storageService: StorageService, eligibilityCheckService: EligibilityCheckService, channelPartnerService: ChannelPartnerService, subventionPreferenceService: SubventionPreferenceService, location: Location) {
        super(router, categorizer, storageService, eligibilityCheckService, channelPartnerService, subventionPreferenceService);
        this.location = location;
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit();
        const state = this.storageService.getObject<{ creditOptions: CreditOptions, eligibilityCheckForm: SharedEligibilityCheckForm }>(OptionsComponent.EXTRA_STATE);
        this.requestedLoanAmount = state.eligibilityCheckForm.requestedAmount;
        this.advanceEmiCount = state.eligibilityCheckForm.advanceEmiOption.advanceEmiCount;
    }

    backToPreviousPage() {
        this.location.back();
    }
}
